import React from 'react';
import { QuizPage } from '../components/QuizPage';
export function Providers({
  onAnswer
}: {
  onAnswer: (ans: string, dq: boolean) => void;
}) {
  return <QuizPage stepNumber={4} question="How many providers see patients in your clinic?" options={[{
    label: 'Just me'
  }, {
    label: '1-3'
  }, {
    label: '4-6'
  }, {
    label: '7+'
  }]} onSelect={opt => onAnswer(opt.label, !!opt.isDq)} data-id="element-151" />;
}